import styled, {keyframes} from 'styled-components';

const placeHolderShimmer = keyframes`
  0% {
    background-position: -46.8rem 0;
  }
  
  100% {
    background-position: 46.8rem 0; 
  }
`;

export const contentLoader = styled.div`
  background: ${props => props.theme.colors.goBrandBlue.medium};
  background-image: linear-gradient(to right, #d1e5ff 0%, #e2efff 20%, #d1e5ff 40%, #d1e5ff 100%);
  background-size: 50rem 3.8rem;
  animation-name: ${placeHolderShimmer};
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: ${props => props.theme.misc.borderRadius.small};
  margin-bottom: ${props => props.theme.spacing.small};
`;

// import styled from 'styled-components';

export const HolidayCalenderWrapper = styled.div(
  props => `
  border-left: .2rem solid ${props.theme.colors.ash.medium};
  width:28rem;
  // background:${props.theme.colors.goWhite.base};
  `,
);

export const HolidayCalenderHeader = styled(contentLoader)(
  props => `
  height:1.5rem;
  width:15rem;
  margin:${props.theme.spacing.xxlarge} 0 ${props.theme.spacing.xlarge} ${props.theme.spacing.large};
  `,
);

export const HolidayListDate = styled(contentLoader)(
  props => `
  height:1.5rem;
  width:6rem;
  margin-right:${props.theme.spacing.base};
  margin-top:${props.theme.spacing.small};
  `,
);

export const HolidayListFestival = styled(contentLoader)(
  props => `
  height:1.5rem;
  width:15rem;
  margin-top:${props.theme.spacing.small};
  `,
);

export const HolidayCalenderListWrap = styled.ul(
  props => `
  height:28rem;
  overflow-y:scroll;
  padding: ${props.theme.spacing.small} ${props.theme.spacing.large};
  `,
);

export const HolidayListItem = styled.li(
  props => `
  display:flex;
  align-items:center;
  box-shadow: 0 .1rem .4rem 0  ${props.theme.colors.shadow.light};
  border-radius: ${props.theme.misc.borderRadius.base};
  padding:${props.theme.spacing.custom(7)} ${props.theme.spacing.large};
  margin-bottom:${props.theme.spacing.large};
  `,
);
